<template>
  <div class="cti-address col-12 whithoutMarginPaddin">
    <div class="col-12 grid fluid whithoutMarginPaddin">
      <!-- Province -->
      <span class="p-field col-12 md:col-4">
        <label for="province"
          >{{ $t("ctiaddress.field.province") }}{{ required ? "*" : "" }}</label
        >
        <Dropdown
          :class="`input input-style ${
            this.required &&
            !this.validations.province &&
            !this.userAddress.province
              ? 'p-invalid'
              : ''
          }`"
          :options="provinceList"
          optionLabel="desProvincia"
          optionValue="codISO"
          v-model="userAddress.province"
          @change="onProvinceChange"
          :disabled="disabled"
        />
        <small
          v-if="
            this.required &&
            !this.validations.province &&
            !this.userAddress.province
          "
          class="p-invalid"
          >{{ this.$t("common.formularios.mandatoryField") }}</small
        >
      </span>
      <!-- Location -->
      <span class="p-field col-8 md:col-6">
        <label for="location"
          >{{ $t("ctiaddress.field.location") }}{{ required ? "*" : "" }}</label
        >
        <div
          :class="`autocomplete ${
            this.required &&
            !this.validations.location &&
            !this.userAddress.location
              ? 'p-invalid'
              : ''
          } ${!userAddress.province ? 'disabled' : ''}`"
        >
          <AutoComplete
            id="location"
            :minLength="3"
            v-model="userAddress.location"
            :forceSelection="true"
            :suggestions="locationSuggestions"
            field="desPoblacion"
            :disabled="disabled || !userAddress.province"
            :loading="false"
            @input="onLocationInput"
            @change="onLocationChange"
            @item-select="changeCP($event)"
          />
          <!-- <InputText
            :class="`input ${
              this.required &&
              !this.validations.location &&
              !this.userAddress.location
                ? 'p-invalid'
                : ''
            }`"
            id="location"
            type="text"
            v-model="localidadSelected"
            :disabled="disabled"
            @change="onLocationChange"
          /> -->
        </div>
        <small
          v-if="
            this.required &&
            !this.validations.location &&
            !this.userAddress.location
          "
          class="p-invalid"
          >{{ this.$t("common.formularios.mandatoryField") }}</small
        >
      </span>
      <!-- Postal Code -->
      <span class="p-field col-4 md:col-2">
        <label for="postalCode"
          >{{ $t("ctiaddress.field.postalCode")
          }}{{ required ? "*" : "" }}</label
        >
        <InputText
          :class="`input ${
            this.required &&
            !this.validations.postalCode &&
            !this.userAddress.postalCode
              ? 'p-invalid'
              : ''
          }`"
          id="postalCode"
          type="text"
          maxlength="5"
          v-model="userAddress.postalCode"
          :disabled="disabled || !userAddress.location"
          @input="onPostalCodeInput"
          @change="onPostalCodeChange"
        />
        <small
          v-if="
            this.required &&
            !this.validations.postalCode &&
            !this.userAddress.postalCode
          "
          class="p-invalid"
          >{{ this.$t("common.formularios.mandatoryField") }}</small
        >
      </span>
      <!-- Type of Road -->
      <span class="p-field col-4 md:col-2">
        <label for="typeOfRoad"
          >{{ $t("ctiaddress.field.typeOfRoad")
          }}{{ required ? "*" : "" }}</label
        >
        <Dropdown
          v-model="userAddress.typeOfRoad"
          :class="`input input-style ${
            this.required &&
            !this.validations.typeOfRoad &&
            !this.userAddress.typeOfRoad &&
            this.userAddress.typeOfRoad !== ''
              ? 'p-invalid'
              : ''
          }`"
          :options="typeOfRoadList"
          optionLabel="desTipoVia"
          optionValue="codTipoVia"
          :disabled="
            disabled ||
            !userAddress.postalCode ||
            userAddress.postalCode.length !== 5
          "
          @change="onTypeOfRoadChange"
        />
        <small
          v-if="
            this.required &&
            !this.validations.typeOfRoad &&
            !this.userAddress.typeOfRoad &&
            this.userAddress.typeOfRoad !== ''
          "
          class="p-invalid"
          >{{ this.$t("common.formularios.mandatoryField") }}</small
        >
      </span>
      <!-- Address -->
      <span class="p-field col-8 md:col-10">
        <label for="address"
          >{{ $t("ctiaddress.field.address") }}{{ required ? "*" : "" }}</label
        >
        <InputText
          :class="`input ${
            this.required &&
            !this.validations.address &&
            !this.userAddress.address
              ? 'p-invalid'
              : ''
          }`"
          id="address"
          type="text"
          v-model="userAddress.address"
          :disabled="
            disabled ||
            !userAddress.postalCode ||
            userAddress.postalCode.length !== 5
          "
          @change="onAddressChange"
          @mouseout="onAddressChange"
        />
        <small
          v-if="
            this.required &&
            !this.validations.address &&
            !this.userAddress.address
          "
          class="p-invalid"
          >{{ this.$t("common.formularios.mandatoryField") }}</small
        >
      </span>
    </div>
    <Dialog
      :header="$t('ctiaddress.modal.title')"
      :visible.sync="displayCTIWarning"
      :modal="true"
      :closable="false"
      :style="{ width: '50vw' }"
    >
      <p>{{ $t("ctiaddress.modal.text") }}</p>
      <div class="grid">
        <Card class="col-12 md:col-6">
          <template #title>
            <div class="card-title">
              <RadioButton :value="userAddress" v-model="selectedAddress" @click="suggestedCTIboolean = false" />
              <p class="radio-text">{{ $t("ctiaddress.modal.useMine") }}</p>
            </div>
          </template>
          <template #content>
            <ul>
              <li>
                <strong>{{ $t("ctiaddress.field.province") }}:</strong>
                {{ getProvinceDescription(userAddress.province) }}
              </li>
              <li>
                <strong>{{ $t("ctiaddress.field.location") }}:</strong>
                {{ typeof(userAddress.location) !== 'string' ? userAddress.location.desPoblacion : userAddress.location }}
              </li>
              <li>
                <strong>{{ $t("ctiaddress.field.postalCode") }}:</strong>
                {{ userAddress.postalCode }}
              </li>
              <li>
                <strong>{{ $t("ctiaddress.field.typeOfRoad") }}:</strong>
                {{ getTypeOfRoadDescription(userAddress.typeOfRoad) }}
              </li>
              <li>
                <strong>{{ $t("ctiaddress.field.address") }}:</strong>
                {{ userAddress.address }}
              </li>
            </ul>
          </template>
        </Card>
        <Card class="col-12 md:col-6">
          <template #title>
            <div class="card-title">
              <RadioButton
                :value="suggestedCTIAddress"
                v-model="selectedAddress"
                @click="suggestedCTIboolean = true"
              />
              <p class="radio-text">
                {{ $t("ctiaddress.modal.useSuggested") }}
              </p>
            </div>
          </template>
          <template #content>
            <ul>
              <li>
                <strong>{{ $t("ctiaddress.field.province") }}:</strong>
                {{ getProvinceDescription(suggestedCTIAddress.province) }}
              </li>
              <li>
                <strong>{{ $t("ctiaddress.field.location") }}:</strong>
                {{ suggestedCTIAddress.location }}
              </li>
              <li>
                <strong>{{ $t("ctiaddress.field.postalCode") }}:</strong>
                {{ suggestedCTIAddress.postalCode }}
              </li>
              <li>
                <strong>{{ $t("ctiaddress.field.typeOfRoad") }}:</strong>
                {{ getTypeOfRoadDescription(suggestedCTIAddress.typeOfRoad) }}
              </li>
              <li>
                <strong>{{ $t("ctiaddress.field.address") }}:</strong>
                {{ suggestedCTIAddress.address }}
              </li>
            </ul>
          </template>
        </Card>
      </div>
      <template #footer>
        <div class="center">
          <Button
            :label="$t('common.buttons.accept')"
            icon="pi pi-check"
            @click="onCTISuggestionClose"
            autofocus
          />
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import CTIService from "@/service/CTIService";
import { PROVINCIAS, TIPOS_VIA } from "@/resources/cti";

const ctiService = new CTIService();

export default {
  name: "CTIAddress",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userAddress: {
        province: "",
        location: "",
        postalCode: "",
        typeOfRoad: "",
        address: "",
      },
      suggestedCTIAddress: {},
      checkedAddress: "",
      provinceList: [],
      locationSuggestions: [],
      typeOfRoadList: [],
      displayCTIWarning: false,
      selectedAddress: null,
      validations: {
        province: true,
        location: true,
        postalCode: true,
        typeOfRoad: true,
        address: true,
      },
      localidadSelected: null,
      suggestedCTIboolean: true
    };
  },
  methods: {
    validate() {
      if (this.required) {
        this.validations = {
          province: !!this.userAddress.province,
          location: !!this.userAddress.location,
          postalCode: !!this.userAddress.postalCode,
          typeOfRoad:
            !!this.userAddress.typeOfRoad || this.userAddress.typeOfRoad === "",
          address: !!this.userAddress.address,
        };
      } else {
        if (this.userAddress.province === "") {
          this.validations = {
            province: true,
            location: true,
            postalCode: true,
            typeOfRoad: true,
            address: true,
          };
        } else {
          this.validations = {
            province: !!this.userAddress.province,
            location: !!this.userAddress.location,
            postalCode: !!this.userAddress.postalCode,
            typeOfRoad:
              !!this.userAddress.typeOfRoad ||
              this.userAddress.typeOfRoad === "",
            address: !!this.userAddress.address,
          };
        }
      }
    },
    login() {
      this.loadProvinceList();
      this.loadTypeOfRoadList();
      ctiService.login();
    },
    valid() {
      this.validate();

      return (
        this.validations.province &&
        this.validations.location &&
        this.validations.postalCode &&
        this.validations.postalCode &&
        this.validations.typeOfRoad &&
        this.validations.address
      );
    },
    getData() {
      return this.userAddress;
    },
    setData(data) {
      this.userAddress.province = data.province;
      this.userAddress.location = data.location;
      this.userAddress.postalCode = data.postalCode;
      this.userAddress.typeOfRoad = data.typeOfRoad;
      this.userAddress.address = data.address;
    },
    loadProvinceList() {
      this.provinceList = PROVINCIAS;
    },
    loadTypeOfRoadList() {
      this.typeOfRoadList = TIPOS_VIA;
    },
    onLocationInput(event) {
      if (event && event.length > 2) {
        let codProvincia = this.provinceList.find(
            (province) => province.codISO === this.userAddress.province
          ).codProvincia
        ctiService
          .locationListByProvinceAndPattern(codProvincia, event)
          .then((response) => {
            this.locationSuggestions = response.data.map(
              (location) => location
            );
          });
      }
    },
    onPostalCodeInput() {
      this.postalCode = this.postalCode
        ? this.postalCode.replace(/[^0-9]/g, "")
        : null;
    },
    changeCP(event) {
      this.userAddress.postalCode = event.value.codPostal
      this.postalCode = event.value.codPostal
      this.onPostalCodeInput()
    },
    onProvinceChange() {
      this.userAddress.location = "";
      this.userAddress.postalCode = "";
      this.userAddress.typeOfRoad = "";
      this.userAddress.address = "";

      this.validations.province = false;
    },
    onLocationChange() {
      this.userAddress.postalCode = "";
      this.userAddress.typeOfRoad = "";
      this.userAddress.address = "";
      if (this.userAddress.location) {
        ctiService
          .locationListByProvinceAndPattern(
            this.userAddress.province,
            this.userAddress.location
          )
          .then((response) => {
            const location = response.data.find(
              (location) => location.desPoblacion === this.location
            );
            if (location) {
              this.userAddress.postalCode = location.codPostal;
            }
          });
      }

      this.validations.location = false;
    },
    onPostalCodeChange() {
      this.userAddress.typeOfRoad = "";
      this.userAddress.address = "";

      this.validations.postalCode = false;
    },
    onTypeOfRoadChange() {
      if (this.userAddress.address) {
        this.onAddressChange();
      }

      this.validations.typeOfRoad = false;
    },
    onAddressChange() {
      if (this.userAddress.address) {
        ctiService
          .normalizeAddress(
            PROVINCIAS.find(
              (provincia) => provincia.codISO === this.userAddress.province
            ).codProvincia,
            this.userAddress.location.desPoblacion,
            this.userAddress.postalCode,
            this.userAddress.typeOfRoad,
            this.userAddress.address
          )
          .then((response) => {
            this.$emit("address:input", false);
            this.$emit("address:dialog", false);
            if (response && response.data) {
              const { data } = response;
              this.suggestedCTIAddress = {
                province: PROVINCIAS.find(
                  (provincia) => provincia.codProvincia === data.codProvincia
                ).codISO,
                location: data.desPoblacion,
                postalCode: data.codPostal,
                typeOfRoad: data.tipoVia ? data.tipoVia : "C",
                address: `${data.desVia}${
                  data.numPortal ? " Nº" + data.numPortal : ""
                }${data.restoDomicilio ? " " + data.restoDomicilio : ""}`,
              };
              this.suggestedCTIAddress.province = this.suggestedCTIAddress.province == "" ?  this.userAddress.province :this.suggestedCTIAddress.province
              this.suggestedCTIAddress.location = this.suggestedCTIAddress.location == "" ?  this.userAddress.location :this.suggestedCTIAddress.location
              if(this.userAddress.typeOfRoad === "")
                this.userAddress.typeOfRoad = "C"
              if (
                JSON.stringify(this.userAddress).toUpperCase() !==
                JSON.stringify(this.suggestedCTIAddress).toUpperCase() && this.suggestedCTIboolean
              ) {
                this.selectedAddress = this.suggestedCTIAddress;
                this.displayCTIWarning = true;
              }
              if(typeof(this.userAddress.location) !== 'string' && this.userAddress.location.desPoblacion.length > 0 )
                this.userAddress.location = this.userAddress.location.desPoblacion
            }
          })
          .catch((error) => {
            console.error(error);
            this.$emit("address:input", false);
            this.$emit("address:dialog", false);
          });
      }

      this.validations.address = true;
    },
    onCTISuggestionClose() {
      this.userAddress = { ...this.selectedAddress };
      this.checkedAddress = this.userAddress.address;
      this.displayCTIWarning = false;
    },
    getProvinceDescription(provinceCode) {
      const result = this.provinceList
        ? this.provinceList.find(
            (province) => province.codISO === provinceCode
          )
        : null;

      return result ? result.desProvincia : "";
    },
    getTypeOfRoadDescription(typeOfRoadCode) {
      const code = typeOfRoadCode ? typeOfRoadCode : "C";
      const result = this.typeOfRoadList
        ? this.typeOfRoadList.find(
            (typeOfRoad) => typeOfRoad.codTipoVia === code
          )
        : null;

      return result ? result.desTipoVia : "";
    },
  },
  mounted() {
    this.login();
  },
  watch: {
    "userAddress.address": {
      handler: function (newValue,oldValue) {
        if (newValue != "" && newValue !==oldValue) {
          this.$emit("address:dialog", true);
          this.suggestedCTIboolean = true
        }
        if (newValue && newValue.toLowerCase() === this.checkedAddress.toLowerCase()) {
          this.$emit("address:input", false);
          this.$emit("address:dialog", false);
        }
      },
      immediate: true,
    },
    localidadSelected(newValue) {
      this.userAddress.location = newValue;
    },
    "userAddress.typeOfRoad"(newValue) {
      if(newValue == "" || newValue == null)
        this.userAddress.typeOfRoad = "C"
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/layout/_variables.scss";

.autocomplete::v-deep input {
  border: none;
  display: flex;
  align-items: center;
  height: 100% !important;
  width: 100% !important;
   &.disabled {
    opacity: 0.5;
  }
}
.p-dropdown::v-deep .p-inputtext {
  display: flex;
  align-items: center;
  height: 100%;
}

.p-autocomplete {
  border: 2px solid $lightBlueBG !important;
  border-radius: 3px;
  height: 48px !important;

  
  .p-autocomplete {
    height: 36px;
    border: none;
    

    .p-autocomplete-input {
      height: inherit !important;
      
    }
  }
}

.p-autocomplete {
  border: 2px solid $lightBlueBG !important;
  border-radius: 3px;
  width: 100% !important;
  line-height: 1.5;
  &.p-invalid {
    border-color: red !important;
  }

  &.disabled {
    opacity: 0.5;
  }

  :first-of-type(input) {
    height: inherit !important;
  }
  
}

.whithoutMarginPaddin {
  margin: 0px;
  padding: 0px;
}
.card-title {
  display: flex;
  align-items: center;
}
.radio-text {
  font-size: 1rem;
  margin: 0;
}
input, .input {
  height: 3rem !important;
}
</style>